import { Box, Typography } from '@mui/material';
import React from 'react';
import { EmptyItem } from '../Icons';

interface DataNotFoundProps {
	Image?: any;
	content?: string;
	operation?: string;
	onClick?: () => void;
	height?: string;
}

const DataNotFound: React.FC<DataNotFoundProps> = ({
	Image = EmptyItem,
	content = 'Item not found',
	operation,
	onClick,
	height = '60vh',
}) => {
	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			width="100%"
			height={height}
		>
			<Image />
			<Typography
				variant="body1"
				style={{
					color: 'var(--lighter-text-color)',
					fontSize: '16px',
					fontWeight: '600',
					textAlign: 'center',
				}}
			>
				{content}
				{operation === 'create' ? (
					<div>
						To get started, click{' '}
						<span
							onClick={onClick}
							style={{
								color: 'var(--default-text-color)',
								fontSize: '16px',
								fontWeight: '600',
								cursor: 'pointer',
							}}
						>
							Create One now
						</span>
					</div>
				) : null}
			</Typography>
		</Box>
	);
};

export default DataNotFound;
